import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {
  computeResourceDiscoveryApiRef,
  ComputeResourceDiscoveryClient,
} from './api';

export const computeResourceDiscoveryPlugin = createPlugin({
  id: 'compute-resource-discovery',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: computeResourceDiscoveryApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory({ discoveryApi, fetchApi }) {
        return new ComputeResourceDiscoveryClient({ discoveryApi, fetchApi });
      },
    }),
  ],
});

export const ComputeResourceDiscoveryContent =
  computeResourceDiscoveryPlugin.provide(
    createRoutableExtension({
      name: 'ComputeResourceDiscoveryContent',
      component: () => import('./components/Router').then(m => m.Router),
      mountPoint: rootRouteRef,
    }),
  );
